import React from 'react';
import { connect } from 'react-redux'
import { NavLink, Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import HomeOutlined from '@mui/icons-material/HomeOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined';
import { logoutUser, getCurrentUser } from '../../actions/userActions';
import { withRouter } from '../../actions/withRouterHook';
import bicloud_logo from '../../images/png/bicloud_logo.png'
import { DatabaseIcon } from '../../images/js/databaseIcon';
import { PresentationIcon } from '../../images/js/presentationIcon';
import { UserIcon } from '../../images/js/userIcon';
import { StatisticsIcon } from '../../images/js/statisticsIcon';
import MenuIcon from '@mui/icons-material/Menu';
import { doesThisUserHaveThisAuthorization } from '../utilities/helperFunctions'

const svgs = {
    "home": <HomeOutlined />,
    "myUser": <UserIcon />,
    "presentations": <PresentationIcon />,
    "databases": <DatabaseIcon />,
    "admin": <SettingsOutlined />,
    "statistics": <StatisticsIcon />,
    "help": <HelpOutlineOutlined />,
}

class Navigation extends React.Component {
    constructor(props) {
        super(props);
        // create a ref to store the textInput DOM element
        this.anchorRef = React.createRef(null);
    }

    state = {
        hover: undefined,
        bigHover: false,
    }

    componentDidMount() {
        if (this.props.currentUser === null && this.props.id !== null) {
            this.props.getCurrentUser(this.props.id)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.currentUser === null && this.props.id) {
            this.props.getCurrentUser(this.props.id)
        }
    }

    handleBigHover = (event) => {
        event.preventDefault()
        this.setState({ bigHover: true })
    }

    handleBigLeave = (event) => {
        event.preventDefault()
        this.setState({ bigHover: false })
    }
     
    handleHover = (event) => {
        this.setState({ hover: event.target.dataset.name })
    }

    handleSVG = (string) => {
        if (this.state.hover === string) {
            return React.cloneElement(
                svgs[string],
                { style: { color: "white" } }
            )
        } else if (this.props.history.location.pathname.includes(string)) {
            return React.cloneElement(
                svgs[string],
                { style: { color: "#FE701E" } }
            )
        }
        else {
            return React.cloneElement(
                svgs[string],
                { style: { color: "#ACB4BD" } }
            )
        }
    }

    renderName = (string) => {
        let name = (string === "myUser") ? "My User" : string
        return (this.state.bigHover) ? (<p style={this.handleTextStyle(string)}>{name}</p>) : null
    }

    handleExit = (event) => {
        this.setState({ hover: undefined })
    }

    handleTextStyle = (string) => {
        let logoStyle = (string === "XP3 BI Cloud") ? { marginTop: "-20px" } : null
        logoStyle = (string === "Home") ? { marginTop: "20px" } : logoStyle
        if (this.state.hover && this.state.hover.toLowerCase() === string.toLowerCase()) {
            return { 'color': "white", ...logoStyle }
        } else if (("/" + string.toLowerCase()) === this.props.history.location.pathname.toLowerCase()) {
            return { 'color': '#FE701E', ...logoStyle }
        } else {
            return { ...logoStyle }
        }
    }

    handleMenuWidth = () => {
        return (this.state.bigHover) ? { 'width': '250px' } : null
    }

    renderOrange = (string) => {
        let style = { 'backgroundColor': '#FE701E' }
        let styleAbout = { "position": "absolute", "top": "0px", "left": "0px", "fontWeight": "bold" }
        if (this.state.hover === string) {
            return (string !== "about") ? style : { ...style, ...styleAbout }
        } else {
            return (string !== "about") ? null : styleAbout
        }
    }

    render() {
        return <div className={this.state.bigHover
            ? 'leftSection showNavigation'
            : 'leftSection'} onMouseEnter={this.handleBigHover} onMouseLeave={this.handleBigLeave}>
            <div className="myIconShow" onClick={this.handleBigHover}>
                <MenuIcon />
            </div>
            <div className="menuScroll">

                <NavLink className="logoTop" to="/about" data-name="XP3 BI Cloud">
                    <span>
                        <img src={bicloud_logo} alt="BI Cloud" />
                    </span>
                    <em>XP3 BI Cloud</em>
                </NavLink>
                <ul>
                    <li>
                        <Link to="/welcome">
                            <HomeOutlined />
                            Home
                        </Link>
                    </li>
                    <li>
                    <Link to="/presentations">
                        <PresentationIcon />
                        Presentation
                    </Link>
                    </li>
                    {(this.props.role === "IEAdmin" || this.props.role === "ClientAdmin"  || (this.props.currentUser && this.props.role === "Builder" && doesThisUserHaveThisAuthorization(this.props.currentUser, "DatabaseFunctions"))) && <li>
                        <Link to="/databasefunctions" target="_blank">
                            <DatabaseIcon />
                            Data Tools
                        </Link>
                    </li>}
                    <li>
                        <Link to="/myUser">
                            <UserIcon />
                            My User
                        </Link>
                    </li>
                    {(this.props.role === "Builder" || this.props.role === "ClientAdmin" || this.props.role === "IEAdmin") && <li>
                        <Link to="/admin">
                            <SettingsOutlined />
                            Admin
                        </Link>
                    </li>}
                    {(this.props.role === "Builder" || this.props.role === "ClientAdmin" || this.props.role === "IEAdmin") && <li>
                        <Link to='/statistics'>
                            <StatisticsIcon />
                            Statistics
                        </Link>
                    </li>}

                    <li>
                        <Link to="/help">
                            <HelpOutlineOutlined />
                            Help
                        </Link>
                    </li>
                </ul>
            </div>
        </div>

    }

}

function mapStateToProps(state) {
    return {
        loggedIn: state.users.loggedIn,
        role: state.users.role,
        currentUser: state.users.currentUser,
        id: state.users.userID
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ logoutUser, getCurrentUser }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navigation))